<template>
    <div class="page" id="offers">
        <header class="pageHeader">
            <fade-image src="assets/headers/offers.png" />
        </header>

        <div id="scroller" class="small">
            <div class="pageHeaderIntro">
                <h1>Offers</h1>
                <img
                    class="icon"
                    style="width: auto; margin-top: -10px"
                    src="~@/assets/icons/headers/offers.svg"
                />
            </div>

            <div v-if="!offers">
                <pre-loader-item v-for="n in 5" :key="n" />
            </div>
            <div v-else-if="Object.keys(offers).length > 0">
                <div v-for="(category, key) in offers" :key="key">
                    <h2 class="subtitle">{{ key }}:</h2>

                    <div class="offerCarousel">
                        <div
                            v-for="offer in category"
                            class="item"
                            :key="offer.id"
                            :class="{ show: offer.qty == null || offer.qty > 0 }"
                        >
                            <router-link :to="{ name: 'offer', params: { id: offer.id } }">
                                <div class="thumbnailSurround">
                                    <img
                                        class="thumbnail"
                                        :src="imageURL(offer.image)"
                                        v-if="offer.image"
                                    />
                                    <img
                                        class="thumbnail"
                                        :src="imageURL(offer.images[0])"
                                        v-else-if="offer.images[0]"
                                    />
                                </div>
                                <span class="offer">{{ offer.title }}</span>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

            <empty-placeholder style="margin-top: 10px" v-else>
                TIP: This area is awaiting updates from your Pro. We'll notify you of any updates
                through the app, so you'll be the first to hear about offers when they are made
                available.
            </empty-placeholder>
        </div>
    </div>
</template>

<script>
import EmptyPlaceholder from "@/components/App/empty-placeholder";
import PreLoaderItem from "@/components/App/Pre-loader-item";
import FadeImage from "@/components/App/fade-image";
import { imageURL } from "@/mixins/imageURL.js";
export default {
    name: "player-offers",
    mixins: [imageURL],
    components: { EmptyPlaceholder, PreLoaderItem, FadeImage },
    created() {
        this.getOffers();
    },
    data() {
        return {
            offers: false,
        };
    },
    methods: {
        getOffers() {
            window.axios.get("/offer").then((offers) => {
                this.offers = offers.data;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#offers {
    .subtitle {
        color: $green_0;
        margin-bottom: 10px;
        margin-top: 10px;
    }
    .offerCarousel {
        white-space: nowrap;
        overflow: auto;
        table-layout: fixed;
        margin-bottom: 20px;
        .item {
            background: $green_1;
            border-radius: 12px;
            width: 320px;
            display: inline-block;
            margin-right: 10px;
            text-decoration: none;
            display: none;
            &.show {
                display: inline-block;
            }
            a {
                text-decoration: none;
            }
            .thumbnailSurround {
                position: relative;
                padding-bottom: 66.66666666666667%;
                overflow: hidden;
                .thumbnail {
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    border-radius: 12px;
                    width: 100%;
                    margin-bottom: 20px;
                    border-radius: 12px;
                    object-fit: cover;
                }
            }
            .offer {
                display: block;
                padding: 10px;
                color: white;
            }

            &:last-of-type {
                margin-right: 0px;
            }
        }
    }
}
</style>
